import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { LandingpageService } from 'src/app/services/landingpage/landingpage.service';
import { Constant } from 'src/app/common/constant/constant';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import * as moment from 'moment';

@Component({
  selector: 'app-repair-order-time-motion',
  templateUrl: './repair-order-time-motion.component.html',
  styleUrls: ['./repair-order-time-motion.component.scss']
})
export class RepairOrderTimeMotionComponent implements OnInit {
  @Input() roId: any = 0;
  @Input() userId: any = 0;
  @Input() domainId: any = 0;
  @Input() innerHeight: any = 600;
  @Output() timeMotionEmit: EventEmitter<any> = new EventEmitter();

  public sconfig: PerfectScrollbarConfigInterface = {};
  public timeLineData:any = [];
  public loading: boolean = true;
  
  constructor(
    private LandingpagewidgetsAPI: LandingpageService
  ) { }

  ngOnInit(): void {
    this.getTimeLineInfo();
  }

  getTimeLineInfo() {
    let apiInfo = {
      apikey: Constant.ApiKey,
      domainId: this.domainId,
      userId: this.userId,
      roId: this.roId,
    };
    console.log(apiInfo)
    this.LandingpagewidgetsAPI.apiGetROTimeLineInfo(apiInfo).subscribe((response) => {
      let timeLineData = response.data;
      timeLineData.forEach(timeItem => {
        let isAdminFlag = (timeItem.isAdminInt == 1) ? true : false;
        timeItem.isAdmin = isAdminFlag;
        if(timeItem.dateStr !='0000-00-00 00:00:00'){
            let createdOn = moment.utc(timeItem.dateStr).toDate(); 
            timeItem.dateStr = moment(createdOn).local().format('MMM DD, YYYY h:mm A');
          }
          else{
           timeItem.dateStr = "-";
          }
      });
      this.timeLineData = timeLineData;
      this.loading = false;
    });
  }

}
